import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgPagination } from './components/paginator/ng-pagination/ng-pagination.component';
import { PaginatorComponent } from './components/paginator/paginator.component';
import { UploadAttachmentFilesComponent } from './components/upload-attachment-files/upload-attachment-files.component';
import { InitialsPipe } from './custom-validators/InitialsPipe';
import { TranslationModule } from './i18n/translation.module';
import { InputFormFieldComponent } from './components/input-validation-base/input-form-field.component';
import { NgSelectFormFieldComponent } from './components/ng-select-validation-base/ng-select-form-field.component';
import { DateTimeFormFieldComponent } from './components/date-time-validation-base/date-time-form-field.component';
import { NgSelectModule } from '@ng-select/ng-select';
@NgModule({
  declarations: [PaginatorComponent, NgPagination, UploadAttachmentFilesComponent, InitialsPipe, InputFormFieldComponent, DateTimeFormFieldComponent, NgSelectFormFieldComponent],
  imports: [CommonModule, FormsModule, TranslationModule, ReactiveFormsModule,NgSelectModule
  ],
  exports: [PaginatorComponent, NgPagination, UploadAttachmentFilesComponent, InitialsPipe, InputFormFieldComponent, DateTimeFormFieldComponent, NgSelectFormFieldComponent],
})
export class SharedModule { }
